import React from 'react';
import { Button } from '@iq/react-components';

export default function UpdateWidget({ updated, isImported, onClick, onSaveLayout }) {
  return updated ? (
    <div className="panel-updated-notice">
      <div className="notice">The layout has been changed and can be previewed.</div>
      <div className="actions">
        <Button
          onClick={onClick}
          activity="secondary"
        >
          Reset
        </Button>
        <Button
          onClick={onSaveLayout}
          activity={isImported ? 'danger' : 'primary'}
        >
          Save changes
        </Button>
      </div>
    </div>
  ) : null;
}
